<template>
	<div class="modal-delete-tag-container flex-col items-center">
		<h5
			class="modal-delete-tag-title text-white font-uppercase"
			v-html="$t('modals.DeleteTagConfirm.title', { count: options.count })"
		/>
		<h6 class="modal-delete-tag-body text-white text-center">
			{{ $tc('modals.DeleteTagConfirm.mainText') }}
		</h6>
		<div class="modal-delete-tag-buttons flex">
			<button class="button-delete font-regular font-uppercase text-black mr-5" @click="onConfirm">
				{{ $tc('modals.DeleteTagConfirm.deleteButtonText') }}
			</button>
			<button class="button-light-blue font-regular font-uppercase text-black ml-5" @click="onClose">
				{{ $tc('modals.DeleteTagConfirm.cancelButtonText') }}
			</button>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalDeleteTagConfirm',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
	.modal-overlay {
			backdrop-filter: blur(20px);
			-webkit-backdrop-filter: blur(20px);
			transition: 0.5s ease-in-out;
		.modal-delete-tag-container {
			max-width: 425px;
			min-height: 288px;
			width: 100%;
			padding: 30px;
			border-radius: 11px;
			backdrop-filter: blur(10px);
			-webkit-backdrop-filter: blur(10px);
			background-color: rgba(40, 40, 40, 0.85);
			box-shadow: 1px 2px 20px 0 rgba(0, 0, 0, 0.4);
			.modal-delete-tag-title {
				letter-spacing: 0.72px;
			}
			.modal-delete-tag-body {
				padding: 36px 55px 50px;
				letter-spacing: 0.98px;

				&.delete-clips {
					padding: 36px 40px 50px;

					.delete-clip-name {
						padding-top: 15px;
						max-width: 300px;
					}
				}
			}

			&.delete-clips-container {
				min-height: 270px;
			}

			.modal-delete-tag-buttons {
				@include respond-below(phone) {
					flex-direction: column;
				}

				button {
					padding: 8px 50px;
					@include respond-below(phone) {
						margin: 5px;
						flex-direction: column;
					}
				}
			}
		}
	}
</style>
